"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformVehicleByVuE = void 0;
exports.transformVehicleByTechData = transformVehicleByTechData;
const applyVueMarketStrategies_1 = require("./strategies/vueMarketStrategies/applyVueMarketStrategies");
const applyMediaEditMarketStrategies_1 = require("./strategies/mediaEditMarketStrategies/applyMediaEditMarketStrategies");
const transformVehicleByVuE = (vue, locale, i18nlanguage) => (0, applyVueMarketStrategies_1.applyVueMarketStrategies)(vue, locale, i18nlanguage);
exports.transformVehicleByVuE = transformVehicleByVuE;
function transformVehicleByTechData(configurationDetails, locale, i18nlanguage) {
    return (0, applyMediaEditMarketStrategies_1.applyMediaEditMarketStrategies)(configurationDetails, locale, i18nlanguage);
}
